import { get, clamp } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Button, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import NumberInput from 'components/NumberInput';

const MaxTrialUserCount = ({
  account,
  updateAccount,
  classes,
}) => {

  const [freeAllocation, setFreeAllocation] = React.useState(null);
  const [isDisabled, setIsDisabled] = React.useState(true);

  React.useEffect(() => {
    setFreeAllocation(get(account, 'trial_max_users', 1));
  }, [account]);

  const handleSetAllocation = ({ target }) => {
    const value = target.value === '' ? null : Number(target.value);

    setIsDisabled(value === null || value === freeAllocation);
    setFreeAllocation(value);
  };

  const handleUpdateAllocation = async () => {
    // update the account
    await updateAccount(account.id, {
      // Allowed range is 0 - 10000
      trial_max_users: clamp(freeAllocation, 1, 1000),
    }, 'Trial user allocation updated');

    setIsDisabled(true);
  };

  return (
    <div className={classes.row}>
      <TextField
        value={freeAllocation}
        onChange={handleSetAllocation}
        error={freeAllocation > 1000}
        helperText="Max allowed allocation is 1000"
        variant="outlined"
        InputProps={{
          inputComponent: NumberInput,
        }}
      />

      <div className={classes.button}>
        <Button
          onClick={handleUpdateAllocation}
          disabled={isDisabled}
        >
          Update
        </Button>
      </div>
    </div>
  );

};

const styles = (theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  button: {
    marginLeft: theme.spacing(1),
  },
});

MaxTrialUserCount.propTypes = {
  account: PropTypes.object.isRequired,
  updateAccount: PropTypes.func.isRequired,
};

export default withStyles(styles)(MaxTrialUserCount);
